import { createFilterOptions } from '@mui/material';
import { User } from '../../auth/interfaces/user';
import { userService } from '../../auth/services/user.service';
import { FilterContentFieldDataTypes } from '../../filter/constants';
import { Filter } from '../../filter/interface';
import { OperandValue } from '../../shared/utils/filters';
import { NotificationsAPI } from '../NotificationsAPI';
import { Recipient, RecipientActionsType } from './interface';
import { RECIPIENT_TYPES } from './constant';

export const createRecipientObjectForUser = (user: User): Recipient => {
  return {
    id: user.id.toString(),
    channel_type: 'user',
    channel_identifier: user.email,
    added_by: '',
    actions: [
      {
        type: RecipientActionsType.SWITCH,
        display_name: 'switch',
        is_disabled: false
      }
    ]
  };
};

export const SEARCH_FILTER_KEY = 'term';

export const getFilterKeyMatchValue = (filterKey: string, item: Recipient): OperandValue => {
  switch (filterKey) {
    case 'added_by':
      return item.added_by;
    case 'channel_type':
      return item.channel_type;

    case SEARCH_FILTER_KEY:
      return item.channel_identifier;
    default:
      return undefined;
  }
};

export const getRecipientFilters = (addedByList: { label: string; value: string }[]): Filter[] => {
  let filters = [
    {
      title: 'Channel type',
      filterKey: 'channel_type',
      filterType: FilterContentFieldDataTypes.LIST,
      filterContentProps: {
        multiple: true,
        options: RECIPIENT_TYPES,
        textFieldProps: {
          forceActiveLegend: true,
          prefixIcon: 'search',
          placeholder: 'Search'
        }
      }
    }
  ];

  if (addedByList.length > 1) {
    filters = [
      {
        title: 'Added by',
        filterKey: 'added_by',
        filterType: FilterContentFieldDataTypes.LIST,
        filterContentProps: {
          multiple: true,
          options: addedByList,
          textFieldProps: {
            forceActiveLegend: true,
            prefixIcon: 'search',
            placeholder: 'Search'
          }
        }
      },
      ...filters
    ];
  }
  return filters;
};

export const getRecipientsIncludingCurrentUser = async () => {
  const res = await NotificationsAPI.getRecipientsList();
  const userAsRecipient = createRecipientObjectForUser(userService.getUser()!);
  const recipients = [userAsRecipient, ...res.data.recipients];

  return recipients;
};

export const filterRecipientsInRecipientDropdown = createFilterOptions({
  matchFrom: 'any',
  stringify: option => (option as Recipient).channel_identifier
});
